import React from "react";
import MuiButton from "@mui/material/Button";
import MuiFormControl from "@mui/material/FormControl";
import MuiTextField from "@mui/material/TextField";
import MuiFormHelperText from "@mui/material/FormHelperText";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiIconButton from "@mui/material/IconButton";
import MuiMenu from "@mui/material/Menu";
import MuiMenuItem from "@mui/material/MenuItem";
import MuiIconLocalization from "@mui/icons-material/Language";
import MuiIconLayersClear from "@mui/icons-material/LayersClear";

// Source
import * as HelperSrc from "../HelperSrc";
import ControllerAuthentication from "../controller/Authentication";
import ControllerLocalization from "../controller/Localization";
import ViewLoader from "./Loader";

let isRendered = false;

const viewPageLogin: React.FC = () => {
    // Variable
    const controllerAuthentication = new ControllerAuthentication("login", isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerAuthentication.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain) {
        return (
            <div className="view_login" data-at_id="view_login">
                <div className="left">
                    <div className="content">
                        <h1>{HelperSrc.NAME}</h1>
                    </div>
                </div>
                <div className="right">
                    <div className="menu">
                        <MuiIconButton data-at_id="menu_locale" name="locale_button" onClick={controllerLocalization.clickOpenLocalization}>
                            <MuiIconLocalization />
                        </MuiIconButton>
                        <MuiMenu
                            anchorEl={controllerLocalization.getElementMenuButton}
                            open={controllerLocalization.getIsLocalizationOpen}
                            onClose={controllerLocalization.closeLocalization}
                        >
                            <MuiMenuItem
                                data-at_id="menu_locale_ja_jp"
                                onClick={() => {
                                    if (controllerAuthentication.getStorageSetting) {
                                        controllerLocalization.clickChange(
                                            controllerAuthentication.getStorageSetting.language_ja,
                                            controllerAuthentication.getStorageSetting.country_jp
                                        );
                                    }
                                }}
                            >
                                <p>{controllerLocalization.getStorageMain.japanese}</p>
                            </MuiMenuItem>
                            <MuiMenuItem
                                data-at_id="menu_locale_en_us"
                                onClick={() => {
                                    if (controllerAuthentication.getStorageSetting) {
                                        controllerLocalization.clickChange(
                                            controllerAuthentication.getStorageSetting.language_en,
                                            controllerAuthentication.getStorageSetting.country_us
                                        );
                                    }
                                }}
                            >
                                <p>{controllerLocalization.getStorageMain.english}</p>
                            </MuiMenuItem>
                        </MuiMenu>
                        <MuiIconButton
                            data-at_id="clear_application"
                            onClick={() => {
                                controllerAuthentication.clickClearApplication();
                            }}
                        >
                            <MuiIconLayersClear />
                        </MuiIconButton>
                    </div>
                    <div className="content">
                        <h1 data-at_id="welcome">{controllerLocalization.getStorageMain.welcome}</h1>
                        <form className="form">
                            <div className="input">
                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (HelperSrc.ENV_NAME === "local" || HelperSrc.ENV_NAME === "dev_jp" || HelperSrc.ENV_NAME === "dev_us") {
                                        html.push(
                                            <div>
                                                <MuiFormControl className="field_container">
                                                    <MuiTextField
                                                        className="field_value"
                                                        variant="outlined"
                                                        name="username"
                                                        data-at_id="login_username"
                                                        label={controllerLocalization.getStorageMain.username}
                                                        placeholder="ex: xxx.xxx@jp.kpmg.com"
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </MuiFormControl>
                                                <MuiFormControl className="field_container">
                                                    <MuiTextField
                                                        className="field_value"
                                                        variant="outlined"
                                                        name="password"
                                                        data-at_id="login_password"
                                                        label={controllerLocalization.getStorageMain.psw}
                                                        placeholder="ex: Pass1234"
                                                        type="password"
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </MuiFormControl>
                                            </div>
                                        );
                                    }

                                    return html;
                                })()}
                            </div>
                            <MuiFormControl className="button_container">
                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (HelperSrc.ENV_NAME === "local" || HelperSrc.ENV_NAME === "dev_jp" || HelperSrc.ENV_NAME === "dev_us") {
                                        html.push(
                                            <MuiButton
                                                className="button_primary"
                                                data-at_id="button_basic_login"
                                                disabled={controllerAuthentication.getApiLoadingList.authentication}
                                                onClick={() => {
                                                    controllerAuthentication.clickBasic();
                                                }}
                                            >
                                                {(() => {
                                                    const html: JSX.Element[] = [];

                                                    if (controllerAuthentication.getApiLoadingList.authentication) {
                                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                                    } else {
                                                        html.push(<>{controllerLocalization.getStorageMain.basic_login}</>);
                                                    }

                                                    return html;
                                                })()}
                                            </MuiButton>
                                        );
                                    }

                                    html.push(
                                        <MuiButton
                                            className="button_primary"
                                            disabled={controllerAuthentication.getApiLoadingList.authentication}
                                            onClick={() => {
                                                controllerAuthentication.clickAd();
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerAuthentication.getApiLoadingList.authentication) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.ad_login}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    );

                                    return html;
                                })()}
                            </MuiFormControl>
                        </form>
                    </div>
                </div>
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageLogin;
